define((require) => {
    "use strict";

    var ImprovedView = require("zbone/ImprovedView"),
        ShowSubWidgetView = require("ui/experience/widgets/dynamicProductWidget/ShowSubWidgetView"),
        DynamicProductWidgetSubtypes = require("shared/ui/experience/widgets/dynamicProductWidget/DynamicProductWidgetSubtypes").default,
        template = require("ui/experience/widgets/dynamicProductWidget/ShowWidgetsView.tpl");

    return ImprovedView.extend({

        template: template,

        model: null,

        regions: {
            toggleImageSubwidgets: ".toggle-image-region",
            togglePriceSubwidgets: ".toggle-price-region",
            toggleTitleSubwidgets: ".toggle-title-region",
            toggleDescriptionSubwidgets: ".toggle-description-region"
        },

        templateHelpers: function() {
            return {
                productIDEntered: (typeof this.model.get("group") !== "undefined")
            };
        },

        onShow: function() {
            this.__super();
            const widgetMap = new Map();

            const mapTypes = [[DynamicProductWidgetSubtypes.Image, this.toggleImageSubwidgets],
                [DynamicProductWidgetSubtypes.Price, this.togglePriceSubwidgets],
                [DynamicProductWidgetSubtypes.Title, this.toggleTitleSubwidgets],
                [DynamicProductWidgetSubtypes.Description, this.toggleDescriptionSubwidgets]];

            mapTypes.forEach((type) => {
                widgetMap.set(type[0], type[1]);
            });

            if (this.model.get("group")) {
                this.model.get("group").forEach((widget) => {
                    const type = widget.get("subtype");
                    widgetMap.get(type).show(new ShowSubWidgetView({
                        subWidgetModels: this.model.get("group").models,
                        model: widget,
                        type: widget.get("subtype"),
                        groupWidgetView: this.options.groupWidgetView
                    }));
                });
            }
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/dynamicProductWidget/ShowWidgetsView.js